module.exports = ".dis-flex {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}"